import React from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useInstallPrompt } from "@/lib/pwa";
import { useLang } from "@/context/LanguageContext";

export const InstallButton = ({ className = "", variant = "outline" }) => {
  const { canInstall, installed, isIOS, promptInstall } = useInstallPrompt();
  const { t } = useLang();
  if (installed) return null;

  const onClick = async () => {
    if (canInstall) { await promptInstall(); return; }
    toast.info(isIOS ? t("install.iosHint") : t("actions.installHintToast"));
  };

  return (
    <Button onClick={onClick} variant="outline" data-testid="nav-install-btn"
      className={`rounded-lg border border-navy/20 bg-white/70 text-navy hover:bg-navy hover:text-white transition-colors ${className}`}>
      <Download className="h-4 w-4 mr-1.5" /> {t("actions.installApp")}
    </Button>
  );
};
